// extracted by mini-css-extract-plugin
export default {"eigengrau":"#101828","avatar":"styles_avatar__2BLDx","userCaption":"styles_userCaption__gJTjB","name":"styles_name__4TxBK"};